module.exports = "what\n<a ng-repeat=\"dateRange in vm.dateRangeOptions\" ng-click=\"selected(dateRange)\">\n  {{ dateRange.label }}\n</a>";